import { LegFlow } from 'models/LegFlow';
import { createAction } from 'typesafe-actions';

export type UpdateFlowTableByCellEditPayload = {
  legNumber: number;
  rowId: number;
  row: LegFlow;
};
export const updateFlowTableByCellEdit = createAction(
  'debtPricer/flows/updateFlowTableByCellEdit',
)<UpdateFlowTableByCellEditPayload>();

export type DeleteFlowRowsPayload = {
  legNumber: number;
  rowIds: number[];
};
export const deleteFlowRows = createAction(
  'debtPricer/flows/deleteFlowRows',
)<DeleteFlowRowsPayload>();
